import { Box, Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';
import { BREAKPOINTS } from '@src/styles/config';

export const StyledPaymentDialog = styled(Dialog)`
  .MuiDialog-paper {
    max-width: 640px;
    min-width: 240px;
    width: 640px;
  }

  .wrapper {
    padding: 16px 32px 32px 32px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .title {
    color: ${COLOR.indigo[100]};
    font-weight: 700;
    font-size: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${COLOR.divider};
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid ${COLOR.divider};
    box-sizing: border-box;
    padding-bottom: 8px;

    .title {
      color: ${COLOR.indigo[100]};
      font-weight: 700;
      font-size: 20px;
      padding-bottom: 0px;
      border-bottom: none;
    }

    .close-icon {
      padding: 4px;
      transform: translateX(8px);
    }
  }

  .dialog-action {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    padding: 0;
    flex-direction: row;

    .button {
      padding: 8px 24px;
      border-radius: 480px;
      text-transform: none;
      margin-left: 0;
    }

    .base-style-btn-payment {
      height: 48px;
      border-radius: 480px;
      padding-top: 8px;
      padding-right: 24px;
      padding-bottom: 8px;
      padding-left: 24px;
      gap: 8px;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.4px;
      text-align: center;
      vertical-align: middle;
    }

    .cancel-transfer-btn {
      width: 155px;
      color: #1c1c1ea3;
    }

    .confirm-transfer-btn {
      width: 424px;
    }

    .cancel-order-button {
      padding: 8px 48px;
      color: rgba(28, 28, 30, 0.48);
      font-size: 16px;
      font-weight: 510;
      line-height: 24px;
      word-wrap: break-word;
      text-transform: none;
      width: fit-content;
      border: none;
      border-radius: 12px;
      margin-left: 0;
    }
    .confirm-order-button {
      padding: 8px 48px;
      color: ${COLOR.darkBlue};
      font-size: 16px;
      font-weight: 510;
      line-height: 24px;
      word-wrap: break-word;
      text-transform: none;
      border-radius: 12px;
      width: fit-content;
      min-width: 300px;
      margin-left: 0;
      letter-spacing: -0.4px;
    }
  }

  @media only screen and (max-width: ${BREAKPOINTS.SM}px) {
    .dialog-action {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 16px;
      padding: 0;

      .button {
        padding: 8px 24px;
        border-radius: 480px;
        text-transform: none;
        margin-left: 0;
      }

      .confirm-order-button {
        padding: 8px 32px;
        min-width: unset;
        width: 100%;
      }
    }

    .cancel-transfer-btn {
      width: 100% !important;
      order: 2;
    }

    .confirm-transfer-btn {
      width: 100% !important;
      order: 1;
    }
  }

  .unit-price {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    text-transform: lowercase;
    padding-bottom: -2px;
  }

  .underlined {
    text-decoration: underline;
  }

  .qr-payment-content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .time {
    font-size: 14px;
    font-weight: 400;
    color: ${COLOR.label[80]};
  }

  .price-value {
    font-weight: 700;
    font-size: 20px;
    color: ${COLOR.black.default} !important;
  }

  .time-value {
    font-weight: 700;
    color: ${COLOR.black.default} !important;
    width: 40px;
    display: inline-block;
  }

  .divider {
    margin: 16px 0;
  }
`;

export const StyledPaymentDialogV2 = styled(Dialog)`
  .MuiDialog-paper {
    max-width: 640px;
    width: 575px;
  }

  .wrapper {
    padding: 16px 32px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .title {
    color: ${COLOR.indigo[100]};
    font-weight: 700;
    font-size: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${COLOR.divider};
  }

  .dialog-action {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    padding: 0;
    flex-direction: column;

    .button {
      padding: 8px 24px;
      border-radius: 480px;
      text-transform: none;
      margin-left: 0;
    }

    .cancel-order-button {
      padding: 8px 48px;
      color: rgba(28, 28, 30, 0.48);
      font-size: 16px;
      font-weight: 510;
      line-height: 24px;
      word-wrap: break-word;
      text-transform: none;
      width: fit-content;
      border: none;
      border-radius: 12px;
      margin-left: 0;
    }
    .confirm-order-button {
      padding: 8px 48px;
      color: ${COLOR.darkBlue};
      font-size: 16px;
      font-weight: 510;
      line-height: 24px;
      word-wrap: break-word;
      text-transform: none;
      border-radius: 12px;
      width: fit-content;
      min-width: 300px;
      margin-left: 0;
      letter-spacing: -0.4px;
    }
  }

  @media only screen and (max-width: ${BREAKPOINTS.SM}px) {
    .wrapper {
      padding: 16px;
    }

    .dialog-action {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 16px;
      padding: 0;

      .button {
        padding: 8px 24px;
        border-radius: 480px;
        text-transform: none;
        margin-left: 0;
      }

      .confirm-order-button {
        padding: 8px 32px;
        min-width: unset;
        width: 100%;
      }
    }
  }

  .unit-price {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    text-transform: lowercase;
    padding-bottom: -2px;
    color: rgba(28, 28, 30, 0.64);
  }

  .underlined {
    text-decoration: underline;
  }

  .qr-payment-content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .time {
    font-size: 14px;
    font-weight: 400;
    color: ${COLOR.label[80]};
  }

  .price-value {
    font-weight: 700;
    font-size: 20px;
    color: ${COLOR.black.default} !important;
  }

  .time-value {
    font-weight: 700;
    color: ${COLOR.black.default} !important;
    width: 40px;
    display: inline-block;
  }

  .divider {
    margin: 16px 0;
  }
`;

export const StyledTransferInformation = styled(Box)`
  display: flex;
  flex-direction: column;

  .saveQR {
    font-size: 12px;
    font-weight: 500;
    color: ${COLOR.indigo[100]};
    text-transform: none;
    height: 30px;
    border-radius: 8px;
    padding: ${(props) =>
      props.usePaymentQRV2 ? '4px 12px 4px 8px' : '4px 16px 4px 8px'};
    width: ${(props) => (props.usePaymentQRV2 ? '150px' : '110px')};
    border: 1px solid ${COLOR.indigo[100]};
    gap: ${(props) => props.usePaymentQRV2 && '4px'};
  }

  .saveQR-improve {
    width: auto;
    font-weight: 510;
    padding: 4px 12px 4px 8px;

    .download-icon {
      font-size: 16px;
      margin-right: 4px;
    }
  }

  .information-wrapper {
    height: 240px;
    position: relative;
  }

  .expired-transaction {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .text {
      font-size: 16px;
      font-weight: 510;
      text-align: center;
    }
  }

  .qr-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
    flex-direction: column;
    align-items: center;

    .button-group {
      display: flex;
      gap: 8px;
      margin-top: 8px;
    }

    .bank-qr {
      width: 160px;
      height: 160px;
    }
  }

  .content-information {
    align-items: baseline;
    flex: 1;

    .row-content {
      display: grid;
      grid-template-columns: 40% 60%;
      margin-bottom: 6px;
    }

    .label {
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
    }

    .value {
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      justify-content: end;
      text-align: end;
      padding-right: ${(props) => !props.usePaymentQRV2 && '10px'};
    }

    .card-number {
      display: flex;
      gap: 5px;
      align-items: center;
    }

    .divider {
      margin: 16px 0;
    }

    .divider-note {
      margin: 16px 0;
    }
  }

  .note {
    display: flex;
    justify-content: space-between;
    gap: 4px;
    opacity: ${(props) => (props.expiredPayment ? 0.4 : 1)};
  }

  @media only screen and (max-width: ${BREAKPOINTS.SM}px) {
    .note {
      display: flex;
      flex-direction: column;
      gap: 4px;
      opacity: ${(props) => (props.expiredPayment ? 0.4 : 1)};
    }

    .content-information {
      .row-content {
        display: block;
        margin-bottom: 6px;
      }

      .value {
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        text-align: left;
        padding-right: ${(props) => !props.usePaymentQRV2 && '10px'};
      }

      .card-number {
        display: flex;
        align-items: center;
        justify-content: ${(props) =>
          props.usePaymentQRV2 ? 'space-between' : 'start'};
      }
    }
  }

  .icon {
    width: 24px;
    height: 24px;
  }

  .note-item {
    display: flex;
    gap: 5px;
    align-items: flex-start;
    background-color: ${TRANSPARENT_COLOR.alert};
    padding: 12px;
    border-radius: 8px;

    &.align-items-center {
      align-items: center !important;
    }

    .note-content {
      display: flex;
      flex-direction: column;
    }

    .note-title {
      font-size: 12px;
      font-weight: 400;
      color: ${COLOR.label[80]};
    }

    .note-description {
      font-size: 14px;
      font-weight: 400;
      color: ${(props) =>
        props.usePaymentQRV2 ? COLOR.black.default : COLOR.label[100]};
    }
  }
`;

export const StyledNotConfirmOrderDialog = styled(Dialog)`
  /* TODO: Not use this way, need to refactor */
  .MuiDialog-container {
    background: rgba(28, 28, 30, 0.32);
    backdrop-filter: blur(12px);
  }

  .circular-progress {
    color: ${COLOR.darkBlue};
  }

  .MuiDialog-paper {
    max-width: ${(props) =>
      ['upgradeDowngradePackV3', 'rolloverOrder', 'voiceCloningQuota'].includes(
        props.dialogName,
      )
        ? '640px'
        : '580px'};
    max-width: ${(props) =>
      ['unpaidOrder', 'notConfirmedOrder'].includes(props.dialogName) &&
      '480px'};
    border-radius: 16px;
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    padding: ${(props) =>
      props.dialogName === 'invalidVoucherForRegion'
        ? '16px 16px 16px 32px'
        : '16px 32px 32px 32px'};
    gap: ${(props) =>
      ['upgradeDowngradePackV3', 'rolloverOrder'].includes(props.dialogName)
        ? '0px'
        : '16px'};
    padding: ${(props) =>
      ['upgradeDowngradePackV3', 'rolloverOrder'].includes(props.dialogName) &&
      '10px 24px 24px 24px'};
    padding: ${(props) =>
      ['unpaidOrder', 'notConfirmedOrder'].includes(props.dialogName) &&
      '12px 24px 24px 24px'};
  }

  @media only screen and (max-width: ${BREAKPOINTS.SM}px) {
    .info-package-mirgate {
      font-size: 17px !important;
    }
    .title-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      /* align-items: flex-start;
    justify-content: flex-start; */
      gap: 4px;
      margin-bottom: ${(props) =>
        ['upgradeDowngradePackV3', 'rolloverOrder'].includes(
          props.dialogName,
        ) && '12px'};
      height: 24px;
    }
    .note-payment {
      font-size: ${(props) =>
        ['upgradeDowngradePackV3', 'rolloverOrder'].includes(
          props.dialogName,
        ) && '12px'} !important;
    }
    .support-payment {
      margin-top: 16px;
      span {
        font-size: ${(props) =>
          ['upgradeDowngradePackV3', 'rolloverOrder'].includes(
            props.dialogName,
          ) && '12px'} !important;
      }
    }
    .title-content {
      font-size: ${(props) =>
        ['upgradeDowngradePackV3', 'rolloverOrder'].includes(
          props.dialogName,
        ) && '16px'} !important;
    }
    .list {
      .item {
        font-size: ${(props) =>
          ['upgradeDowngradePackV3', 'rolloverOrder'].includes(
            props.dialogName,
          ) && '14px'} !important;
        letter-spacing: -0.4px;
        .MuiTypography-root {
          font-size: ${(props) =>
            ['upgradeDowngradePackV3', 'rolloverOrder'].includes(
              props.dialogName,
            ) && '14px'} !important;
        }
        margin-bottom: ${(props) =>
          ['upgradeDowngradePackV3', 'rolloverOrder'].includes(
            props.dialogName,
          ) && '0px'} !important;
      }
    }
    .MuiDialog-paper {
      width: ${(props) =>
        [
          'exceedsCharacters',
          'confirmPayment',
          'upgradeDowngradePackV3',
          'rolloverOrder',
        ].includes(props.dialogName) && '343px'} !important;
      margin: ${(props) =>
        [
          'exceedsCharacters',
          'confirmPayment',
          'upgradeDowngradePackV3',
          'rolloverOrder',
        ].includes(props.dialogName) && '0px'} !important;
      max-width: 580px;
      border-radius: 16px;
    }

    .action-confirm-payment {
      display: flex;
      flex-direction: column;
      .check-box-not-show-again {
        margin-right: auto;
      }

      .action-btn {
        width: 100%;
        .action-button-contained {
          width: 50%;
        }
        .action-button-outline {
          width: 50%;
        }
      }
    }

    .action-confirm-updowngrade {
      display: flex;
      flex-direction: column;
      .check-box-not-show-again {
        margin-right: auto;
      }

      .action-btn {
        width: 100%;
        .action-button-contained {
          padding: 8px;
          width: 150px;
        }
        .action-button-outline {
          padding: 8px;
          width: 150px;
        }
      }
    }

    .wrapper {
      display: flex;
      flex-direction: column;
      padding: ${(props) =>
        [
          'exceedsCharacters',
          'confirmPayment',
          'upgradeDowngradePackV3',
          'rolloverOrder',
        ].includes(props.dialogName) && '12px 16px 12px 16px'};
      gap: ${(props) =>
        [
          'exceedsCharacters',
          'confirmPayment',
          'upgradeDowngradePackV3',
          'rolloverOrder',
        ].includes(props.dialogName) && '0px'};
    }
    .title-content {
      width: max-content;
    }
  }

  .pending-order-content {
    .description {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: -0.4px;
      color: #1c1c1e;
      margin-bottom: 8px;
    }
    .note {
      display: flex;
      align-items: flex-start;
      gap: 4px;
      box-sizing: border-box;
      border-radius: 8px;
      gap: 8px;
      padding: 12px;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.4px;
      vertical-align: middle;
      background-color: #ff950014;
      img {
        width: 20px;
        margin-top: 2px;
      }
    }
  }

  .voice-cloning-quota-notice {
    color: ${COLOR.darkGray};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.4px;

    ul {
      padding-left: 16px;
    }
  }

  .title-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    /* align-items: flex-start;
    justify-content: flex-start; */
    gap: 4px;
    margin-bottom: ${(props) =>
      ['upgradeDowngradePackV3', 'rolloverOrder'].includes(props.dialogName) &&
      '10px'};
  }

  .title-container {
    display: flex;
    gap: 8px;
  }

  .title-content {
    font-size: 20px;
    font-weight: 700;
    line-height: 32px;
    color: ${(props) =>
      [
        'invalidVoucherForRegion',
        'confirmPayment',
        'exceedsCharacters',
        'upgradeDowngradePackV3',
        'rolloverOrder',
        'unpaidOrder',
        'notConfirmedOrder',
      ].includes(props.dialogName)
        ? COLOR.darkGray
        : COLOR.indigo[100]};
  }

  .content {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: ${(props) =>
      props.dialogName === 'invalidVoucherForRegion'
        ? COLOR.darkGray
        : COLOR.indigo[100]};
    padding: 8px 0px;
  }

  .action-confirm-payment {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .not-show-again-text {
      color: ${COLOR.indigo[100]};
    }
    .action-btn {
      display: flex;
      align-items: center;
      .action-button-outline {
        height: 40px;
        padding: 8px 24px;
        box-sizing: border-box;
        margin-right: 8px;
        border: 1px solid #1e164e52;
        font-weight: 700;
        border-radius: 12px;
        font-size: 14px;
        text-transform: none;
      }
    }
  }

  .action-confirm-updowngrade {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .not-show-again-text {
      color: ${COLOR.indigo[100]};
    }
    .action-btn {
      display: flex;
      align-items: center;
      .action-button-outline {
        height: 40px;
        padding: 8px 24px;
        box-sizing: border-box;
        margin-right: 8px;
        border: 1px solid #1e164e52;
        font-weight: 700;
        border-radius: 12px;
        font-size: 14px;
        text-transform: none;
      }
    }
  }

  .action-button-contained {
    height: 40px;
    padding: 8px 24px;
    text-transform: none;
    border-radius: 12px;
    box-sizing: border-box;
    font-weight: 700;
    font-size: 14px;
    width: 120px;

    &:disabled {
      pointer-events: all;
      opacity: 0.5;
      background-color: ${COLOR.primary};
      cursor: not-allowed;
    }
  }

  @media only screen and (max-width: ${BREAKPOINTS.SM}px) {
    .action-button-contained {
      height: 40px;
      padding: 8px 24px;
      text-transform: none;
      border-radius: 12px;
      box-sizing: border-box;
      font-weight: 700;
      font-size: 14px;
      width: 100%;
    }
  }

  .actions-pending-orders {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    .base-style-pending-order {
      height: 40px;
      border-radius: 12px;
      gap: 8px;
      border-width: 1px;
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.4px;
      text-align: center;
      vertical-align: middle;
      text-transform: none;
    }
    .cancel-button {
      border: 1px solid #1e164e52;
    }
  }
  @media only screen and (max-width: ${BREAKPOINTS.SM}px) {
    .actions-pending-orders {
      flex-direction: column;
      gap: 16px;
      .cancel-button {
        order: 2;
        width: 100%;
      }
      .pending-button {
        order: 1;
        width: 100%;
      }
    }
  }

  .action-wrapper {
    display: flex;
    justify-content: center;
    gap: 24px;

    .action-button {
      width: 100%;
      text-transform: none;
      height: 44px;
      padding: 8px 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      letter-spacing: -0.4px;
      border-radius: 500px;
    }

    .cancel-button {
      border: 1px solid ${COLOR.secondary[32]};
      color: ${COLOR.indigo[100]};
    }

    .pending-button {
      border: 1px solid transparent;
      color: ${COLOR.indigo[100]};
    }

    .new-action-button {
      display: flex;
      height: 40px;
      padding: 8px 24px;
      justify-content: center;
      align-items: center;
      gap: 8px;
      border-radius: 12px;
      width: 100%;
      text-transform: none;
    }
  }
  .action-wrapper-understood {
    display: flex;
    justify-content: right;
    gap: 8px;
    .understood-button {
      width: 160px;
      ${(props) =>
        props.dialogName === 'invalidVoucherForRegion' &&
        `      color: ${COLOR.darkBlue};
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;`}
    }
    .width-auto {
      width: auto;
    }
  }
  @media only screen and (max-width: ${BREAKPOINTS.SM}px) {
    .action-wrapper {
      flex-wrap: wrap;
      flex-direction: column-reverse;
      gap: 14px;
    }
    .action-wrapper-understood {
      flex-direction: row;
      justify-content: center;
    }
  }
`;
